export default __webpack_public_path__ + "images/84b0f66164ebb9e032d613e5822a9b7f-pagination_infinite_do.svg";